import api from './api';

export const createGroup = async (name) => {
  const response = await api.post('/groups', { name });
  return response.data;
};

export const getMyGroup = async () => {
  const response = await api.get('/groups/me');
  return response.data;
};

export const inviteMember = async (email) => {
  const response = await api.post('/groups/invite', { email });
  return response.data;
};

export const cancelInvite = async (inviteId) => {
  const response = await api.delete(`/groups/invites/${inviteId}`);
  return response.data;
};

export const removeMember = async (userId) => {
  const response = await api.delete(`/groups/members/${userId}`);
  return response.data;
};

export const leaveGroup = async () => {
  const response = await api.post('/groups/leave');
  return response.data;
};

export const getInviteByToken = async (token) => {
  const response = await api.get(`/invites/${token}`);
  return response.data;
};

export const acceptInvite = async (token) => {
  const response = await api.post(`/invites/${token}/accept`);
  return response.data;
};
